<template>
  <ul class="mt-2">
    <li v-for="value in refObj" :key = "value.post_id">
      <p  style="width:100%;">
        <router-link :to="`/article/detail/${value.post_id}`" :title="value.post_title">{{ value.post_title }}</router-link>
      <span>{{ moment(created).format("YYYY-MM-DD") }}</span>
      </p>
    </li>
  </ul>
</template>

<script>
import base from '@/core/base.js'
export default {
  name: 'Article',
  mixins: [base]
}
</script>
